/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
4.8.20
Tree Inventory Display: Displays data for viewing & prior to submission
**********************************************************/
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import TreeInventoryTransactionTable from './tree_inventory_transaction_table';

const propTypes = {
  inventory: PropTypes.object,
  inventoryTransactions: PropTypes.array
};

const TreeInventoryMasterDisplay = ({ inventory, inventoryTransactions, employeeIssued, employeeReceived }) => {
  if (!inventoryTransactions) return <div></div>;
  return (
    <div>
      <div>
        <span className="right"><i className="material-icons indigo-text lighten-2 medium">assignment</i></span>
        <span className="app-log-header"><u>Inventory Master</u></span>
        <span className="app-log-prev-header">{ inventory.location === '71' ? '71 - Kau' : '72 - Keaau' }, { inventory.physicalLocation }</span><hr />
        {
          inventoryTransactions.length > 0 ?
            <div className="row">
              <h5 className="blue-text app-log-prev-header">All Transactions</h5>
              <TreeInventoryTransactionTable inventory={inventoryTransactions} readOnly={true} />
            </div>
          : ''
        }
        <div className="row">
          <div className="col s6 m4 l4 xl4 b-r">
            <strong>Inventory Total</strong>
            <h5>{ inventory.inventoryTotal }</h5>
          </div>
          <div className="col s6 m4 l4 xl4 b-r">
            <strong>Inventory Received</strong>
            <h5>{ inventory.inventoryReceived }</h5>
          </div>
          <div className="col s6 m4 l4 xl4 b-r">
            <strong>Inventory Issued</strong>
            <h5>{ inventory.inventoryIssued }</h5>
          </div>
          <div className="col s12">
            <hr />
            <br />
            <div className="divider"></div>
            <div className="section chem-app-flex">
              <p><b>Last Date Received: </b>{ inventory.lastDateReceived ? moment(inventory.lastDateReceived).format('YYYY-MM-DD') : 'N/A' }</p> <br />
              <p><b>Last Date Issued: </b>{ inventory.lastDateIssued ? moment(inventory.lastDateIssued).format('YYYY-MM-DD') : 'N/A' }</p> <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


TreeInventoryMasterDisplay.propTypes = propTypes;
export default TreeInventoryMasterDisplay;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/tree_replant/tree_inventory_master_display.js